module.exports = __webpack_public_path__ + "img/symbol_4.d614f446.png";